import LeaveDateRangePickerController from './LeaveDateRangePickerController';

export default LeaveDateRangePickerController;
